import { render, staticRenderFns } from "./DriverList.vue?vue&type=template&id=37f8b0a4&scoped=true&"
import script from "./DriverList.vue?vue&type=script&lang=js&"
export * from "./DriverList.vue?vue&type=script&lang=js&"
import style0 from "./DriverList.vue?vue&type=style&index=0&id=37f8b0a4&lang=less&scoped=true&"
import style1 from "./DriverList.vue?vue&type=style&index=1&id=37f8b0a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f8b0a4",
  null
  
)

export default component.exports